<template>
  <div>
    <!-- Filters -->
    <taxes-list-filters
      :tax-filter.sync="taxTypeFilter"
      :taxes-options="taxesOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Affichage</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Taxes</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                variant="primary"
                @click="$router.push({ name: 'apps-tax-add' })"
              >
                <span class="text-nowrap">Ajouter Taxe</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refTaxesListTable"
        class="position-relative"
        :items="fetchTaxesList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Pas de taxes trouvé"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Label -->
        <template #cell(rate)="data">
          <span>
            {{ data.item.rate }}%
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(type)="data">
          <b-badge :variant="data.item.type == 'facture' ? 'primary' : 'warning'" class="text-capitalize">
            {{ data.item.type }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              :id="`tax-row-${data.item.id}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer text-warning"
              size="16"
              @click="
                $router.push({
                  name: 'apps-tax-edit',
                  params: { id: data.item.id },
                })
              "
            />
            <b-tooltip
              title="Modifier"
              class="cursor-pointer"
              :target="`tax-row-${data.item.id}-edit-icon`"
            />

            <feather-icon
              :id="`tax-row-${data.item.id}-delete-icon`"
              icon="TrashIcon"
              size="16"
              class="mx-1 text-danger"
              v-if="data.item.created_by != null"
              @click="deleteTax(data.item.id)"
            />
            <b-tooltip
              v-if="data.item.created_by != null"
              title="Supprimer Taxe"
              :target="`tax-row-${data.item.id}-delete-icon`"
            />
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} taxes</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalTaxes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BTooltip,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import TaxesListFilters from "./TaxesListFilters.vue";
import useTaxesList from "./useTaxesList";

export default {
  name: "TaxesList",
  components: {
    TaxesListFilters,

    BTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const {
      fetchTaxesList,
      tableColumns,
      perPage,
      currentPage,
      totalTaxes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTaxesListTable,
      refetchData,
      toggleTaxe,
      deleteTax,

      // Extra Filters
      taxTypeFilter,
      taxesOptions,
    } = useTaxesList();

    return {
      fetchTaxesList,
      tableColumns,
      perPage,
      currentPage,
      totalTaxes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTaxesListTable,
      refetchData,
      toggleTaxe,
      deleteTax,

      taxTypeFilter,
      taxesOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
